import React from 'react';
import { withRouter, NavLink } from 'react-router-dom';
import { connect } from 'react-redux';
import Select from 'react-select';

import DeleteReserveDayModal from './DeleteModal';
import ReserveDayDetailsModal from './DetailsModal';
import Spin from '../../../components/loading';
import ShowForPermission from '../../../components/ShowForPermission';

import ENUMS from '../../../enums/index';
import * as reserveTimeActions from '../../../redux/reserveTimes/actions';
import { enumHelper } from '../../../utils';
import generateClassName from '../../../utils/generateClassName';
import AlertAndConfirmation from '../../../utils/AlertAndConfirmation';

class ReserveDaysListTable extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      sortType: 'asc',
      reservationDayOpen: false,
      selectedReservationDayId: null,
      deleteReservationDayOpen: false,
      reservationDayDetailsOpen: false,
      status: '',
      isActive: false,
      sortedColumn: ''
    };
  }

  sortTable = query => {
    this.setState({ sortedColumn: query });
    this.props.sortTable(query);
  };

  closeDeleteReserveDayModal = () => {
    this.props
      .fetchAllReservationDays(`pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`)
      .then(() => {
        this.setState(() => ({
          deleteReservationDayOpen: false
        }));
      });
  };

  closeReserveDayDetailsModal = () => {
    this.setState({ reservationDayDetailsOpen: false });
  };

  displayDeleteReserveDayModal = id => {
    let { reservationDaysList = [] } = this.props;
    let selectedReservationDayId = reservationDaysList.filter(reservationDay => reservationDay.id == id)[0]
      .id;
    this.setState({ deleteReservationDayOpen: true, selectedReservationDayId });
  };

  displayReserveDayDetailsModal = id => {
    let { reservationDaysList = [] } = this.props;
    let selectedReservationDayId = reservationDaysList.filter(reservationDay => reservationDay.id == id)[0]
      .id;
    this.setState({ reservationDayDetailsOpen: true, selectedReservationDayId });
  };

  handleStatusChange = (id, status) => {
    this.props.changeReservationDayStatus(id, status).then(() => {
      AlertAndConfirmation({
        title: locales('titles.editionsDoneSuccessfully'),
        text: '',
        type: 'success'
      });
      this.props.fetchAllReservationDays(
        `pageNumber=${this.props.pageNumber}&pageSize=${this.props.pageSize}`
      );
    });
  };

  renderStatusColors = status => {
    switch (status) {
      case 'OPEN':
        return 'text-success';
      case 'CLOSE':
        return 'text-danger';
      case 'SUSPENDED':
        return 'text-warning';
      default:
        return 'text-info';
    }
  };

  render() {
    let {
      reservationDaysList = [],
      pageNumber,
      pageSize,
      loading,
      changeReservationDayStatusLoading,
      changeReservationDayStatusError,
      changeReservationDayStatusFailed,
      changeReservationDayStatusMessage,
      sortType
    } = this.props;
    return (
      <>
        <Spin spinning={loading || changeReservationDayStatusLoading}>
          {changeReservationDayStatusError && (
            <div className="alert alert-danger">{locales('messages.server.error')}</div>
          )}
          {changeReservationDayStatusFailed && (
            <div className="alert alert-danger">{changeReservationDayStatusMessage}</div>
          )}
          <table className="table table-hover table-light table-striped">
            <thead>
              <tr>
                <th className="text-center">{locales('tables.row')}</th>
                <th onClick={() => this.sortTable('date')} className="text-center pointer">
                  <i name="date" className={generateClassName('date', this.state.sortedColumn, sortType)} />
                  {locales('tables.specifictionDate')}
                </th>
                <th className="text-center ">{locales('tables.dayMealPortion')}</th>
                <th className="text-center">{locales('tables.reservationType')}</th>
                <th className="text-center">{locales('tables.status')}</th>
                <th onClick={() => this.sortTable('createdFullName')} className="text-center pointer">
                  <i
                    name="createdFullName"
                    className={generateClassName('createdFullName', this.state.sortedColumn, sortType)}
                  />
                  {locales('tables.creator')}
                </th>

                <th className="text-center"></th>
                {/* <th className="text-center"></th> */}
                <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_DATES_LIST_FOR_ADMIN}>
                  <th onClick={() => this.sortTable('cafeName')} className="text-center pointer">
                    <i
                      name="cafeName"
                      className={generateClassName('cafeName', this.state.sortedColumn, sortType)}
                    />
                    {locales('fields.cafe.name')}
                  </th>
                </ShowForPermission>
                <th className="text-center"></th>
                <th className="text-center"></th>
                <th className="text-center"></th>
              </tr>
            </thead>
            <tbody>
              {reservationDaysList.length ? (
                reservationDaysList.map((reservationDay, index) => (
                  <tr key={reservationDay.id}>
                    <td className="text-center">{(pageNumber - 1) * pageSize + index + 1}</td>
                    <td className="text-center">{reservationDay.date}</td>
                    <td className="text-center">
                      {reservationDay.meals && reservationDay.meals.length
                        ? ENUMS.MEAL_PORTIONS.list
                            .filter(item => reservationDay.meals.some(ele => ele.mealType == item.value))
                            .map((ele, index, self) => ` ${ele.title} ${index < self.length - 1 ? '،' : ''}`)
                        : '---'}
                    </td>
                    <td className="text-center">
                      {reservationDay.reserveTypes &&
                        reservationDay.reserveTypes.length &&
                        ENUMS.RESERVATION_TYPES.list
                          .filter(item => reservationDay.reserveTypes.some(ele => ele == item.value))
                          .map((ele, index, self) => ` ${ele.title} ${index < self.length - 1 ? '،' : ''}`)}
                    </td>
                    <td className={`text-center ${this.renderStatusColors(reservationDay.status)}`}>
                      {enumHelper.convertEnumValueToTitle(
                        ENUMS.RESERVATION_STATUS.list,
                        reservationDay.status
                      )}
                    </td>
                    <td className="text-center">{reservationDay.createdFullName}</td>
                    <td>
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_STATUS_CAFE_DATE}>
                        <Select
                          name="tableNumber"
                          className="p-0 col-9"
                          isMulti={false}
                          placeholder={enumHelper.convertEnumValueToTitle(
                            ENUMS.RESERVATION_STATUS.list,
                            reservationDay.status
                          )}
                          options={ENUMS.RESERVATION_STATUS.list.map(status => ({
                            label: status.title,
                            value: status.value
                          }))}
                          onChange={selectedStatus =>
                            this.handleStatusChange(reservationDay.id, selectedStatus.value)
                          }
                        />
                      </ShowForPermission>
                    </td>
                    <ShowForPermission permission={ENUMS.PERMISSIONS.values.VIEW_CAFE_DATES_LIST_FOR_ADMIN}>
                      <td className="text-center">{reservationDay.cafeName}</td>
                    </ShowForPermission>
                    <td title={locales('titles.editReserveDay')}>
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_CAFE_DATE}>
                        <NavLink
                          to={{
                            pathname: '/reservation-days/add-or-edit',
                            reservationDayId: reservationDay.id,
                            editMode: true
                          }}
                        >
                          <i className="text-center fa fa-pencil text-secondary pointer" />
                        </NavLink>
                      </ShowForPermission>
                    </td>
                    <td title={locales('titles.deleteReserveDay')}>
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.DELETE_CAFE_DATE}>
                        <i
                          onClick={() => this.displayDeleteReserveDayModal(reservationDay.id)}
                          className="text-center fal fa-trash text-danger pointer"
                        />
                      </ShowForPermission>
                    </td>
                    <td title={locales('titles.seeReserveHours')}>
                      <ShowForPermission permission={ENUMS.PERMISSIONS.values.EDIT_CAFE_DATE}>
                        <NavLink
                          to={{
                            pathname: `/reservation-day/hours/${reservationDay.id}`
                          }}
                        >
                          <i className="text-center fal fa-clock text-success pointer" />
                        </NavLink>
                      </ShowForPermission>
                    </td>
                  </tr>
                ))
              ) : (
                <tr className="col-12 text-center">
                  <td className="alert alert-info" colSpan={12}>
                    {locales('alerts.noRecord')}
                  </td>
                </tr>
              )}
            </tbody>
          </table>

          {this.state.deleteReservationDayOpen && (
            <DeleteReserveDayModal
              title={this.state.selectedTitle}
              isOpen={this.state.deleteReservationDayOpen}
              reservationDayId={this.state.selectedReservationDayId}
              closeModal={this.closeDeleteReserveDayModal}
            />
          )}
          {this.state.reservationDayDetailsOpen && (
            <ReserveDayDetailsModal
              title={this.state.selectedTitle}
              isOpen={this.state.reservationDayDetailsOpen}
              reservationDayId={this.state.selectedReservationDayId}
              closeModal={this.closeReserveDayDetailsModal}
            />
          )}
        </Spin>
      </>
    );
  }
}

const mapStateToProps = state => {
  return {
    reservationDaysList: state.reserveTimesReducer.reservationDaysList,
    reservationDays: state.reserveTimesReducer.reservationDays,
    loading: state.reserveTimesReducer.loading,

    changeReservationDayStatusLoading: state.reserveTimesReducer.changeReservationDayStatusLoading,
    changeReservationDayStatusFailed: state.reserveTimesReducer.changeReservationDayStatusFailed,
    changeReservationDayStatusError: state.reserveTimesReducer.changeReservationDayStatusError,
    changeReservationDayStatusMessage: state.reserveTimesReducer.changeReservationDayStatusMessage
  };
};

const mapDispatchToProps = dispatch => {
  return {
    fetchAllReservationDays: query => dispatch(reserveTimeActions.fetchAllReservationDays(query)),
    changeReservationDayStatus: (id, status) =>
      dispatch(reserveTimeActions.changeReservationDayStatus(id, status))
  };
};

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(ReserveDaysListTable)
);
